<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div v-loading="loading">
			<img :src="PZUrl">
		</div>
	</div>
</template>
<script>
	import {
		previewCertificate
	} from "@/api/dictionary";

	import vHead from "../../components/Subhead.vue";
	import { Uploader, Toast, Button, Dialog } from "vant";
	import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
	import { getSessionStore } from "@/utils/sessionStorage.js"

	export default {
		data() {
			return {
				codeUrl: 'http://www.csf.org.cn/mobile/#/memberInfo?code=',
				title: "查看聘任证书",

				userInfo: {
					id: "",
					name: "未登录",
					memberTypes: ''
				},
				cardName: "card.png",
				loading: false,
				PZUrl: "", //头像地址

			};
		},

		components: {
			vHead,
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Button.name]: Button,
			[Dialog.name]: Dialog,
		},
		computed: {
			...mapGetters(["commond", "isGroupMember", "getMemberType"]),
			id() {
				return this.$route.query && this.$route.query.id
			}
		},
		methods: {
			...mapActions([
				"getMemberTypeList",
			]),

			getDisplay() {
				this.loading = true
				previewCertificate({ id: this.id }).then(res => {
					if (res.success) {
						this.PZUrl = res.result;
						this.loading = false
					} else {
						Toast.fail(res.message);
						this.loading = false
					}
				});
			},

		},
		async created() {
			this.getDisplay()
		},
		mounted: async function () {

		}
	};
</script>

<style lang="less" scoped>
	img {
		width: 100%;
	}
</style>